import { render, staticRenderFns } from "./JeeFileResourceUpload.vue?vue&type=template&id=5604a014&"
import script from "./JeeFileResourceUpload.vue?vue&type=script&lang=js&"
export * from "./JeeFileResourceUpload.vue?vue&type=script&lang=js&"
import style0 from "./JeeFileResourceUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports